import React, { useState, useEffect } from 'react';
import { getConsolidated } from '../api';
import './ConsolidatedData.css';

function ConsolidatedData() {
  const [data, setData] = useState({ byMonth: {}, byLine: {}, byReason: {}, totalValue: 0, valueByMonth: {}, valueByLine: {} });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAllFiles();
  }, []);

  const loadAllFiles = async () => {
    try {
      const empresaId = localStorage.getItem('empresaId') || 'default';
      const consolidated = await getConsolidated(empresaId);
      setData({
        byMonth:      consolidated.by_month       || {},
        byLine:       consolidated.by_line        || {},
        byReason:     consolidated.by_reason      || {},
        totalValue:   consolidated.total_value    || 0,
        valueByMonth: consolidated.value_by_month || {},
        valueByLine:  consolidated.value_by_line  || {}
      });
    } catch (err) {
      console.error('Erro ao carregar dados consolidados:', err.message);
    }
    setLoading(false);
  };

  if (loading) return <div className="loading">Carregando...</div>;

  const totalFines = Object.values(data.byMonth).reduce((a, b) => a + b, 0);
  const avgValue   = totalFines > 0 ? data.totalValue / totalFines : 0;

  const maxVal = (obj) => Math.max(...Object.values(obj)) || 1;

  return (
    <div className="consolidated-data">
      <div className="kpi-grid">
        <div className="kpi-card">
          <div className="kpi-icon">💰</div>
          <div className="kpi-content">
            <span className="kpi-label">Valor Total</span>
            <span className="kpi-value">{data.totalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
          </div>
        </div>
        <div className="kpi-card">
          <div className="kpi-icon">📊</div>
          <div className="kpi-content">
            <span className="kpi-label">Total de Multas</span>
            <span className="kpi-value">{totalFines}</span>
          </div>
        </div>
        <div className="kpi-card">
          <div className="kpi-icon">📈</div>
          <div className="kpi-content">
            <span className="kpi-label">Valor Médio</span>
            <span className="kpi-value">{avgValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
          </div>
        </div>
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <h3>Multas por Mês</h3>
          <div className="chart-content">
            {Object.keys(data.byMonth).length === 0 ? (
              <p className="empty-chart">Nenhum dado disponível</p>
            ) : (
              Object.entries(data.byMonth).sort().map(([month, count]) => (
                <div key={month} className="chart-row">
                  <span className="chart-label">{month}</span>
                  <div className="chart-bar-container">
                    <div className="chart-bar" style={{ width: `${(count / maxVal(data.byMonth)) * 100}%` }}>
                      <span>{count}</span>
                    </div>
                  </div>
                  <span className="chart-value">{(data.valueByMonth[month] || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="chart-card">
          <h3>Top 10 Linhas</h3>
          <div className="chart-content">
            {Object.keys(data.byLine).length === 0 ? (
              <p className="empty-chart">Nenhum dado disponível</p>
            ) : (
              Object.entries(data.byLine).sort((a, b) => b[1] - a[1]).slice(0, 10).map(([line, count]) => (
                <div key={line} className="chart-row">
                  <span className="chart-label">{line}</span>
                  <div className="chart-bar-container">
                    <div className="chart-bar" style={{ width: `${(count / maxVal(data.byLine)) * 100}%` }}>
                      <span>{count}</span>
                    </div>
                  </div>
                  <span className="chart-value">{(data.valueByLine[line] || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="chart-card full-width">
          <h3>Top 10 Motivos</h3>
          <div className="chart-content">
            {Object.keys(data.byReason).length === 0 ? (
              <p className="empty-chart">Nenhum dado disponível</p>
            ) : (
              Object.entries(data.byReason).sort((a, b) => b[1] - a[1]).slice(0, 10).map(([reason, count]) => (
                <div key={reason} className="chart-row">
                  <span className="chart-label">{reason}</span>
                  <div className="chart-bar-container">
                    <div className="chart-bar" style={{ width: `${(count / maxVal(data.byReason)) * 100}%` }}>
                      <span>{count}</span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsolidatedData;
